import React from "react";

import DonationArea from "./DonationArea";

export class UserActionArea extends React.Component {
  render() {
    const { user, entity, menu, assets, hasExternalUrls, campaign } = this.props;

    return (
      <div className="m-site-btn-group--nav-context user-action-area">
        <DonationArea
          assets={assets}
          entity={entity}
          menu={menu}
          user={user}
          hasExternalUrls={hasExternalUrls}
          campaign={campaign}
        />
      </div>
    );
  }
}

export default UserActionArea;
